module.exports = __webpack_public_path__ + "static/media/discord.7989351e.svg";